module.exports = [
  require('./eladrin_autumn'),
  require('./eladrin_spring'),
  require('./eladrin_summer'),
  require('./eladrin_winter'),
  require('./elder_tempest'),
  require('./elemental_myrmidon_earth'),
]
